// extracted by mini-css-extract-plugin
export default {"backButton":"gj1LJxj4","backIcon":"Y7JeNoOx"};